import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-grid-simmer",
  templateUrl: "./grid-simmer.component.html",
  styleUrls: ["./grid-simmer.component.css"],
})
export class GridSimmerComponent implements OnInit {
  @Input() shimmerType: any;

  constructor() {}

  ngOnInit(): void {}
}
